import React from 'react';
import { Result, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const ProjectCompleted = () => {
  const { t } = useTranslation('project_container');

  return (
    <div
      style={{
        padding: '50px',
        background: '#001e3c',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Result
        icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
        title={<span style={{ color: '#fff' }}>{t('assessment_completed_successfully')}</span>}
        subTitle={<span style={{ color: '#ccc' }}>{t('assessment_completion_message')}</span>}
      />
    </div>
  );
};

export default ProjectCompleted;
